import React from "react";
import styles from "./news_subscription.module.scss";

export const NewsSubscription = () => {
  return (
    <>
      {/* <div className={styles.subscription_form_wrapper}>
        <form>
          <h4 className={styles.subscription_title}>Never Miss any News</h4>
          <div className={styles.subscription_text}>
            Sign up for free and be the first to get notified about updates.
          </div>
          <input
            className={styles.subscription_input}
            type="text"
            placeholder="Type your email here"
          />
          <div className={styles.subscription_btn_wrapper}>
            <button
              type="submit"
              className={`${styles.subscription_btn} btn btn-secondary btn-md`}
            >
              Subscribe Now
            </button>
          </div>
        </form>
      </div> */}
    </>
  );
};

export default NewsSubscription;
